import { isAndroid, isNativePlatform } from '../../../services/native/platformService.js';

export const ANDROID_TEST_STEP_PRODUCT_ID = 900001;
export const ANDROID_TEST_SUBSCRIPTION_PRODUCT_ID = 'step_test_monthly';
export const ANDROID_TEST_SUBSCRIPTION_BASE_PLAN_ID = 'monthly';

export const ANDROID_TEST_SUBSCRIPTION_PRODUCT = {
  product_id: ANDROID_TEST_STEP_PRODUCT_ID,
  product_name: 'STEP Test Monthly',
  product_tag_line: 'Android billing test subscription',
  product_description: '<p>Test subscription product for Google Play Billing internal testing.</p>',
  product_icon_url: '',
  offer_price: 10,
  original_price: 10,
  subscription_price: 10,
  country: 0,
  android_billing: {
    type: 'subscription',
    product_id: ANDROID_TEST_SUBSCRIPTION_PRODUCT_ID,
    base_plan_id: ANDROID_TEST_SUBSCRIPTION_BASE_PLAN_ID,
    offer_id: null,
  },
  __androidTestProduct: true,
};

export function isAndroidNativeBillingEnabled() {
  return isNativePlatform() && isAndroid();
}

export function isAndroidBillingProduct(product) {
  return isAndroidNativeBillingEnabled() && product?.android_billing?.type === 'subscription';
}

export function withAndroidSubscriptionBilling(product) {
  if (!isAndroidNativeBillingEnabled() || !product?.product_id) return product;

  return {
    ...product,
    android_billing: {
      type: 'subscription',
      product_id: String(product.product_id),
      // The native plugin selects the active base plan returned by Google Play.
      base_plan_id: null,
      offer_id: null,
      ...product.android_billing,
    },
  };
}

export function withAndroidSubscriptionBillingList(products = []) {
  return (Array.isArray(products) ? products : []).map(withAndroidSubscriptionBilling);
}

export function appendAndroidTestSubscriptionProduct(products = []) {
  const visibleProducts = Array.isArray(products) ? products : [];
  if (!isAndroidNativeBillingEnabled()) return visibleProducts;

  const alreadyPresent = visibleProducts.some((product) =>
    Number(product?.product_id) === ANDROID_TEST_STEP_PRODUCT_ID
      || product?.android_billing?.product_id === ANDROID_TEST_SUBSCRIPTION_PRODUCT_ID,
  );
  return alreadyPresent ? visibleProducts : [...visibleProducts, ANDROID_TEST_SUBSCRIPTION_PRODUCT];
}

export function isAndroidTestStepProductId(productId) {
  return Number(productId) === ANDROID_TEST_STEP_PRODUCT_ID;
}
